export default __webpack_public_path__ + "static/center-phone-c4f9252b1dfe9296371f1f169bb802fd.webp";